export default "__VITE_ASSET__D70K0jfW__"